<template>
  <div class="sustainability-reporting">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text img-and-text-sm">
        <div class="text-group">
          <h3 class="text-accent">{{ $t("sustainability-reporting-1") }}</h3>
          <h1>{{ $t("sustainability-reporting-2") }}</h1>
          <h2>{{ $t("sustainability-reporting-3") }}</h2>
          <button @click="isReportingModalOpen = true">
            {{ $t("sustainability-reporting-4") }}
          </button>
        </div>
      </div>
      <div class="img-and-btn">
        <Carousel :imgs="imgs" />
      </div>
    </div>
    <transition name="fade">
      <ReportingModal
        v-if="isReportingModalOpen"
        @close="isReportingModalOpen = false"
      />
    </transition>
  </div>
</template>

<script>
import Carousel from "./Carousel";
import ReportingModal from "../shared/ReportingModal.vue";
export default {
  data() {
    return {
      isReportingModalOpen: false,
      imgs: [
        require("../../assets/img/sustainability/reporting/img_right.jpg"),
        // require('../../assets/img/sustainability/gdpr/2.jpg')
      ],
    };
  },
  components: {
    Carousel,
    ReportingModal,
  },
  methods: {
    toggleScroll() {
      const btn = document.getElementsByClassName("btn-arrow")[0];
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: btn.getBoundingClientRect().bottom + scrollTop,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sustainability-reporting {
  position: relative;
}
.mobile {
  display: none;
}

.text-group {
  button {
    border-radius: 50px;
    padding-right: 2rem;
    padding-left: 2rem;
    background-color: #164194;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    line-height: 100%;
    text-transform: initial;
  }
}

@media screen and (max-width: 1000px) {
  .row-1 {
    padding: $sidesPadding1280 0 0;
    flex-direction: column;
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .img-and-text {
      width: 100%;
      .row-1-top-img {
        width: 100%;
      }
      .text-group {
        margin: 0;
        padding: 0 $sidesPadding1280;
      }
    }
    .img-and-btn {
      width: 100%;
      padding: 0;
      .carousel {
        height: 50vw;
      }
      .carousel,
      img {
        width: 100%;
        margin: 0;
      }
      .btn-arrow {
        display: none;
      }
    }
  }

  .text-group {
    button {
      margin-bottom: 20px;
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 600px) {
  .row-1 {
    padding: $sidesPadding600 0 0;
    .img-and-text {
      .text-group {
        padding: 0 $sidesPadding600;
      }
    }
  }

  .text-group {
    button {
      font-size: 12px;
    }
  }
}
</style>
